<template>
  <v-dialog width="500" v-model="showForm">
    <v-btn v-if="model" class="ma-0" slot="activator" small>
      <!-- TGSS -->
      <v-icon v-if="model.status_tgss === 'realizado'" color="primary">mdi-check</v-icon>
      <v-icon v-else-if="model.status_tgss === 'no_procede'" color="grey">
        mdi-checkbox-blank-circle-outline
      </v-icon>
      <v-icon v-else color="error">mdi-circle-off-outline</v-icon>

      <!-- APLIFISA -->
      <v-icon v-if="model.status_aplifisa === 'realizado'" color="primary">mdi-check</v-icon>
      <v-icon v-else-if="model.status_aplifisa === 'no_procede'" color="grey">
        mdi-checkbox-blank-circle-outline
      </v-icon>
      <v-icon v-else color="error">mdi-circle-off-outline</v-icon>

      <!-- SEPE -->
      <v-icon v-if="model.status_sepe === 'realizado'" color="primary">mdi-check</v-icon>
      <v-icon v-else-if="model.status_sepe === 'no_procede'" color="grey">
        mdi-checkbox-blank-circle-outline
      </v-icon>
      <v-icon v-else color="error">mdi-circle-off-outline</v-icon>
      <!-- CLIENTE -->
      <v-icon v-if="model.status_cliente === 'realizado'" color="primary">mdi-check</v-icon>
      <v-icon v-else-if="model.status_cliente === 'no_procede'" color="grey">
        mdi-checkbox-blank-circle-outline
      </v-icon>
      <v-icon v-else color="error">mdi-circle-off-outline</v-icon>
    </v-btn>
    <v-card class="pa-3">
      <v-card-title>
        <h2>Acciones de control</h2>
      </v-card-title>
      <v-container fluid>
        <v-layout row>
          <v-flex xs6>
            <h4 for="">TGSS</h4>
            <v-radio-group v-model="model.status_tgss">
              <v-radio
                v-for="s in status"
                :key="`tgss-${s.value}`"
                :label="s.label"
                :value="s.value"
              ></v-radio>
            </v-radio-group>
            <h4 for="">SEPE</h4>
            <v-radio-group v-model="model.status_sepe">
              <v-radio
                v-for="s in status"
                :key="`tgss-${s.value}`"
                :label="s.label"
                :value="s.value"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs6>
            <h4 for="">Aplifisa</h4>
            <v-radio-group v-model="model.status_aplifisa">
              <v-radio
                v-for="s in status"
                :key="`tgss-${s.value}`"
                :label="s.label"
                :value="s.value"
              ></v-radio>
            </v-radio-group>

            <h4 for="">Cliente</h4>
            <v-radio-group v-model="model.status_cliente">
              <v-radio
                v-for="s in status"
                :key="`tgss-${s.value}`"
                :label="s.label"
                :value="s.value"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-btn @click="closeForm()">
          {{ $t('Cancel') }}
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn color="primary" @click="saveForm()">
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  name: 'ControlStatusButton',
  components: {},
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: null,
          status_tgss: 'pendiente',
          status_aplifisa: 'pendiente',
          status_sepe: 'pendiente',
          status_cliente: 'pendiente',
        };
      },
    },
  },
  data() {
    return {
      status: [
        { value: 'realizado', label: 'Realizado' },
        { value: 'pendiente', label: 'Pendiente' },
        { value: 'no_procede', label: 'No Procede' },
      ],
      showForm: false,
    };
  },
  mounted() {},
  computed: {
    model: {
      set: function(value) {
        this.$emit('input', value);
      },
      get: function() {
        return this.value;
      },
    },
  },
  methods: {
    closeForm() {
      this.showForm = false;
    },
    async saveForm() {
      const data = {
        status_tgss: this.model.status_tgss,
        status_aplifisa: this.model.status_aplifisa,
        status_sepe: this.model.status_sepe,
        status_cliente: this.model.status_cliente,
      };

      try {
        await apiCtrl.put(`/laboral-requests/${this.model.id}/control-status`, data);
        this.closeForm();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
